<template>
  <div class="tableCom">
    <!--:cell-style="{'text-align':'center'}"
    :header-cell-style="{fontSize: '20px',color:'#303133'}"
    :row-style="{fontSize: '20px',color:'#303133'}"
    sortable="custom"
    stripe
    style="width: 100%"
    size="small"
    element-loading-text="加载中"-->
    <el-table
      :data="tableData"
      :header-cell-style="{fontSize: '13px',color:'#515a6e'}"
      border
      v-bind="$attrs"
      v-on="$listeners"
    >

      <template v-for="(item,index) in tableColumn">

        <template v-if="item.type === 'index'">
          <el-table-column
                  :key="index"
                  type="index"
                  :width="item.width || '80px'"
                  align="center"
                  :label="item.label"
          >
          </el-table-column>
        </template>

        <template v-else-if="item.slotName">
          <el-table-column
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  :width="item.width"
                  align="center"
          >
            <template slot-scope="scope">
              <slot
                      :name="item.slotName"
                      :row="scope.row"
                      :$index="scope.$index"
              ></slot>
            </template>
          </el-table-column>
        </template>

        <template v-else-if="item.tableLabel">
          <el-table-column
                  :key="index"
                  align="center"
                  :label="item.label"
                  :width="item.width"
          >
            <template v-for="col in item.tableLabel">
              <el-table-column
                      :key="col.label"
                      align="center"
                      :label="col.label"
                      :width="col.width"
                      :prop="col.prop"
              >
              </el-table-column>
            </template>
          </el-table-column>
        </template>

        <template v-else>
          <template v-if="item.tooltip">
            <el-table-column
                    :key="index"
                    align="center"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
            >
              <template slot-scope="scope">
                <el-tooltip :content="scope.row[item.prop] || '--'" effect="light" placement="bottom">
                  <span class="oneText">{{scope.row[item.prop] || '--'}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
                    :key="index"
                    align="center"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    :sortable="item.sortable || false"
            >
              <template slot-scope="scope">
                <span>{{ scope.row[item.prop] || '--' }}</span>
              </template>
            </el-table-column>
          </template>
        </template>

      </template>

    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TableCom',
  props: {
    tableData: {
      type: Array,
      default: () => ([])
    },
    tableColumn: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<style scoped lang="less">
  .tableCom{
    .oneText {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
</style>
